import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { IvrComponent } from './ivr.component';
import { IvrListComponent } from './ivr-list/ivr-list.component';
import { IvrDetailsComponent } from './ivr-details/ivr-details.component';
import { IvrResolver } from './ivr-details/ivr.resolver';
import { IvrsResolver } from './ivrs.resolver';
import { IvrMsisdnsResolver } from './ivr-details/ivr-msisdns.resolver';
import { InboundableMsisdnResolver } from './inboundable-msisdns.resolver';
var ɵ0 = {
    permissions: {
        only: ['MANAGE_IVR_PERMISSION']
    }
};
var routes = [
    {
        path: 'ivr',
        component: IvrComponent,
        canActivate: [Ng1LoadedGuard],
        canLoad: [NgxPermissionsGuard],
        data: ɵ0,
        children: [
            {
                path: '',
                component: IvrListComponent,
                resolve: {
                    ivrs: IvrsResolver
                }
            },
            {
                path: 'add',
                component: IvrDetailsComponent,
                resolve: {
                    msisdns: InboundableMsisdnResolver
                }
            },
            {
                path: ':id',
                component: IvrDetailsComponent,
                resolve: {
                    ivr: IvrResolver,
                    msisdns: InboundableMsisdnResolver,
                    assignedMsisdns: IvrMsisdnsResolver
                }
            }
        ]
    }
];
var IvrRoutingModule = /** @class */ (function () {
    function IvrRoutingModule() {
    }
    return IvrRoutingModule;
}());
export { IvrRoutingModule };
export { ɵ0 };
